export default "__VITE_ASSET__0d77c2af__"